module.exports = __webpack_public_path__ + "img/new-categorias.69282793.svg";